var map = {
	"./2021-esignature.png": "c961",
	"./advantages-of-ocr.png": "288d",
	"./cant-find-shopping-receipts.png": "be4f",
	"./how-to-use-scanner-image.png": "7cdd",
	"./how-to-use-scanner.png": "57fb",
	"./increase-productivity.png": "b474",
	"./keep-docs-secure.png": "2723",
	"./organize-business-cards.png": "1d75",
	"./scanner-for-business-hr.png": "461a",
	"./support-homeschool.png": "b3ef",
	"./what-is-ocr.png": "96a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "415e";